import { IonSpinner } from "@ionic/react";
import { FunctionComponent } from "react";
import styled from "styled-components";
import { accountDarkGrey } from "utilities/variables/colors";

const FlexContainer = styled.div`
	display: flex;
	justify-content: center;

	ion-spinner {
		color: ${accountDarkGrey};
	}
`;

const LoadingSpinner: FunctionComponent = () => {
	return (
		<FlexContainer>
			<IonSpinner />
		</FlexContainer>
	);
};

export default LoadingSpinner;
